import { useEffect, useState } from "react";
import ApiRequestLogService from "../../../services/ApiRequestLogService";
import { ApiRequestLogResponse } from "../../shared/entities/ApiRequestLogResponse";
import { FloatingPanelFooter } from "../../shared/components/FloatingPanelFooter";
import { TranslationService } from "../../../services/TranslationService";
import { ToastService } from "../../shared/bootstrap/Toast";

const copyText = (text: string) => {
  navigator.clipboard.writeText(text);
  ToastService.showToast(
    TranslationService.translate.CopiedToClipboard,
    undefined,
    "success"
  );
};

const ApiRequestLogDetail = ({
  id,
  onClose
}: {
  id: number;
  onClose?: () => void;
}) => {
  const [item, setItem] = useState<ApiRequestLogResponse.Item | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDetail = async () => {
      setLoading(true);
      setError(null);
      const result = await ApiRequestLogService.get(id);
      if (result instanceof Error) {
        setError("Error al obtener el detalle");
        setItem(null);
      } else if (result && result.item) {
        setItem(result.item);
      }
      setLoading(false);
    };
    fetchDetail();
  }, [id]);

  return (
    <div className="floatingBody p-4">
      <div className="ps-3 d-flex h-100 flex-column">
        {loading && <div>Cargando...</div>}
        {error && <div style={{ color: "red" }}>{error}</div>}
        {item && (
          <>
            <MiniTable
              data={[
                { title: "ID", value: item.ApiRequestLogID?.toString() },
                {
                  title: "Fecha",
                  value: item.Created
                    ? new Date(item.Created).toLocaleString()
                    : ""
                },
                { title: "Usuario", value: (item as any).UserID?.toString() },
                { title: "Método", value: (item as any).Method },
                { title: "Exitoso", value: (item as any).Ok ? "Sí" : "No" },
                { title: "Recibidos", value: (item as any).Count?.toString() },
                {
                  title: "Procesados",
                  value: (item as any).Processed?.toString()
                },
                {
                  title: "Completado",
                  value: (item as any).Completed
                    ? new Date((item as any).Completed).toLocaleString()
                    : ""
                }
              ]}
            />
            <hr className="w-100" />
            <div className="row">
              <div className="col-5">
                <label className="d-flex align-items-center">
                  <b>Request</b>
                  <i
                    className="fal fa-copy is-link px-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => copyText(item.Request)}
                  />
                </label>
                <div
                  style={{
                    background: "#f8f8f8",
                    padding: 8,
                    borderRadius: 4,
                    maxHeight: 300,
                    maxWidth: "100%",
                    overflow: "auto"
                  }}
                >
                  <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
                    {(() => {
                      try {
                        return JSON.stringify(
                          JSON.parse(item.Request),
                          null,
                          2
                        );
                      } catch {
                        return item.Request;
                      }
                    })()}
                  </pre>
                </div>
              </div>
              <div className="col-7">
                <label className="d-flex align-items-center">
                  <b>Response</b>
                  <i
                    className="fal fa-copy is-link px-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => copyText(item.Response)}
                  />
                </label>
                <div
                  style={{
                    background: "#f8f8f8",
                    padding: 8,
                    borderRadius: 4,
                    maxHeight: 300,
                    maxWidth: "100%",
                    overflow: "auto"
                  }}
                >
                  <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
                    {(() => {
                      try {
                        return JSON.stringify(
                          JSON.parse(item.Response),
                          null,
                          2
                        );
                      } catch {
                        return item.Response;
                      }
                    })()}
                  </pre>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <FloatingPanelFooter>
        {onClose && (
          <button className="btn btn-secondary mt-2" onClick={onClose}>
            Cerrar
          </button>
        )}
      </FloatingPanelFooter>
    </div>
  );
};

type MiniTableData = { title?: string; value?: string | (() => JSX.Element) };

const MiniTable = ({ data }: { data: MiniTableData[] }) => (
  <div className="row">
    {data.map((x, i) => (
      <div key={x.title || i} className="col-6 mb-1">
        <div className="row">
          {x.title ? (
            <div className="col-4">
              <label>{x.title}</label>
            </div>
          ) : null}
          <div className="col-8">
            {x.value && (typeof x.value === "string" ? x.value : x.value())}
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default ApiRequestLogDetail;
